//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      showCancellation: false,
      top: 0
    }
  },
  methods: {
    onClickLeft () {
      this.$router.goBack()
    },
    goInfo () {
      this.$router.push({
        path: '/user-info'
      })
    },
    logout () {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('detail')
      localStorage.removeItem('token');
      this.$router.push({
        path: '/login'
      })
    },
    goAbout () {
      this.$router.push({
        path: '/about'
      })
    },
    goPrivary () {
      this.$router.push({
        path: '/privacy'
      })
    }, 
    goAgree () {
      this.$router.push({
        path: '/userAgreement'
      })
    },
  },
  created () {
    if (this.$global.isApp) {
      this.top = api.safeArea.top
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/setting.vue